module.exports = __webpack_public_path__ + "static/media/for-students-24-25.addad2cb.png";